// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    listEmployees as getStaffAPI,
    getEmployee as getEmployeeAPI,
    addEmployee as addEmployeeAPI,
    updateEmployee as updateEmployeeAPI,
    deleteEmployee as deleteEmployeeAPI
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { staffApiResponseError, staffApiResponseSuccess } from './actions';
import { StaffActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getEmployee({ payload: { id } }) {
    try {
        const response = yield call(getEmployeeAPI, id );
        const empleado = response.data.data;
        // NOTE - You can change this according to response format from your api
        // api.setLoggedInUser(user);
        // setAuthorization(user['token']);
        yield put(staffApiResponseSuccess(StaffActionTypes.GET_EMPLOYEE, empleado));
    } catch (error) {
        yield put(staffApiResponseError(StaffActionTypes.GET_EMPLOYEE, error));
        // api.setLoggedInUser(null);
        // setAuthorization(null);
    }
}

/**
 * List contactos
 */
function* listEmployees() {
    try {
        const response = yield call(getStaffAPI);
        const listaEmpleados = response.data.data;
        
        yield put(staffApiResponseSuccess(StaffActionTypes.LIST_EMPLOYEES, listaEmpleados));
    } catch (error) {
        yield put(staffApiResponseError(StaffActionTypes.LIST_EMPLOYEES, error));
    }
}

function* addEmployee({payload:employee}){
    try{
        const response = yield call(addEmployeeAPI,{...employee})
        const empleado = response.data.data
        yield put(staffApiResponseSuccess(StaffActionTypes.ADD_EMPLOYEE,empleado))
    }catch(error){
        yield put(staffApiResponseError(StaffActionTypes.ADD_EMPLOYEE,error))
    }
}

function* updateEmployee({payload:employee}){
    try{
        const response = yield call(updateEmployeeAPI,{...employee})
        const empleado = response.data.data
        yield put(staffApiResponseSuccess(StaffActionTypes.UPDATE_EMPLOYEE,empleado))
    }catch(error){
        yield put(staffApiResponseError(StaffActionTypes.UPDATE_EMPLOYEE,error))
    }
}

function* deleteEmployee({payload:{id}}){
    try{
        const response = yield call(deleteEmployeeAPI,id)
        const empleado = response.data.id
        yield put(staffApiResponseSuccess(StaffActionTypes.DELETE_EMPLOYEE,empleado))
    }catch(error){
        yield put(staffApiResponseError(StaffActionTypes.DELETE_EMPLOYEE,error))
    }
}


export function* watchGetEmployee(): any {
    yield takeEvery(StaffActionTypes.GET_EMPLOYEE, getEmployee);
}

export function* watchListEmployees(): any {
    yield takeEvery(StaffActionTypes.LIST_EMPLOYEES, listEmployees);
}

export function* watchAddEmployee():any{
    yield takeEvery(StaffActionTypes.ADD_EMPLOYEE, addEmployee);
}

export function* watchUpdateEmployee(): any{
    yield takeEvery(StaffActionTypes.UPDATE_EMPLOYEE, updateEmployee);
}
export function* watchDeleteEmployee(): any{
    yield takeEvery(StaffActionTypes.DELETE_EMPLOYEE, deleteEmployee);
}


function* employeesSaga(): any {
    yield all([
        fork(watchGetEmployee),
        fork(watchListEmployees),
        fork(watchAddEmployee),
        fork(watchUpdateEmployee),
        fork(watchDeleteEmployee),
    ]);
}

export default employeesSaga;
